<template>
	<div v-if="product">
		<template v-if="product.stock.enabled">
			<div class="form-group" v-if="product.type === 'variable'">
				<div class="row variable-item-stock d-flex align-items-center my-4 py-3 mx-0 apply-to-all">
					<div class="col-md-6 my-2">
						Ubah Semua Stock
					</div>
					<div class="col-md-6 d-flex my-2">
						<div class="input-group">
							<input type="text" class="input form-control disabled" :class="{
								error: globalStockQty < 0 && isFieldError('product', 'stock_variable')
							}" min="0" disabled="disabled" v-model="globalStockQty" @input="onGlobalStockChange" />
							<div class="input-group-append">
								<button type="button" class="pc-stock-edit btn btn-default btn-icon"
									v-tooltip="'Adjust Stock'" @click="
										showAdjustStock(
											globalStockQty,
											'global',
											true,
										)
										">
									<i class="material-icons text-info">edit</i>
								</button>
								<button type="button" class="pc-stock-edit btn btn-default btn-icon"
									v-tooltip="'Reduce Stock'" @click="showReduceStock('global', true)">
									<i class="material-icons text-danger">remove</i>
								</button>
								<button type="button" class="pc-stock-edit btn btn-default btn-icon"
									v-tooltip="'Add Stock'" @click="showAddStock('global', true)">
									<i class="material-icons text-success">add</i>
								</button>
							</div>
							<span class="error-messages"
								v-if="globalStockQty < 0 && isFieldError('product', 'stock_variable')">{{
									getErrorMessage('product', 'stock_variable') }}</span>
						</div>
					</div>
				</div>
				<label><b>Stock Quantities</b></label>
				<div class="variable-item-stocks">
					<div class="variable-item-stock" v-for="(variation, index) in product.variations
						.prices" :key="index">
						<div class="variable-item-stock-name">
							{{ variation.name.split('||').join(' - ') }}
						</div>
						<div>
							<div class="input-group">
								<input type="text" class="input form-control" :class="{
									disabled: isEditProduct && !isNewVariation(variation), error: variation.stock.quantity < 0 && isFieldError('product', 'stock_variable')
								}" min="0" v-model="variation.stock.quantity" @input="onVariableStockChange(variation)"
									:disabled="isEditProduct && !isNewVariation(variation)" />
								<div class="input-group-append" v-if="isEditProduct && !isNewVariation(variation)
									">
									<button type="button" class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="'Adjust Stock'" @click="
											showAdjustStock(
												variation.stock.quantity,
												variation.name,
											)
											">
										<i class="material-icons text-info">edit</i>
									</button>
									<button type="button" class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="'Reduce Stock'" @click="showReduceStock(variation.name)">
										<i class="material-icons text-danger">remove</i>
									</button>
									<button type="button" class="pc-stock-edit btn btn-default btn-icon"
										v-tooltip="'Add Stock'" @click="showAddStock(variation.name)">
										<i class="material-icons text-success">add</i>
									</button>
								</div>
								<span class="error-messages"
									v-if="variation.stock.quantity < 0 && isFieldError('product', 'stock_variable')">{{
										getErrorMessage('product', 'stock_variable') }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div :class="{
					'col-sm-12': isFullWidth,
					'col-sm-6': !isFullWidth,
				}" v-if="product.type === 'simple'">
					<div class="form-group">
						<label><b>Stock Quantity - {{ stockTypeLabel }}</b></label>
						<div class="input-group">
							<input type="text" min="0" class="input form-control"
								:class="{ error: isFieldError('product', 'stock_simple') }" v-model="productStockQuantity"
								:disabled="isEditProduct" @input="onStockChange" />
							<div class="input-group-append" v-if="isEditProduct">
								<button type="button" class="pc-stock-edit btn btn-default btn-icon"
									v-tooltip="'Adjust Stock'" @click="
										showAdjustStock(productStockQuantity)
										">
									<i class="material-icons text-info">edit</i>
								</button>
								<button type="button" class="pc-stock-edit btn btn-default btn-icon"
									v-tooltip="'Reduce Stock'" @click="showReduceStock()">
									<i class="material-icons text-danger">remove</i>
								</button>
								<button type="button" class="pc-stock-edit btn btn-default btn-icon" v-tooltip="'Add Stock'"
									@click="showAddStock()">
									<i class="material-icons text-success">add</i>
								</button>
							</div>
						</div>
						<p class="error-messages"
							v-if="productStockQuantity <= 0 && isFieldError('product', 'stock_simple')">
							{{
								getErrorMessage('product', 'stock_simple') }}</p>
					</div>
				</div>
			</div>
		</template>

		<template v-if="!product.stock.enabled">
			<div class="form-group">
				<label><b>Stock Status</b></label>
				<select name="stock_status" class="form-control" v-model="product.stock.status">
					<option :value="1">In Stock</option>
					<option :value="0">Out of Stock</option>
				</select>
			</div>
		</template>

		<div class="form-group hidden">
			<label><b>Stock Visibility</b></label>
			<select name="stock_status" class="form-control" v-model="product.stock.visible">
				<option :value="true">Visible</option>
				<option :value="false">Hide in checkout page</option>
			</select>
		</div>

		<!-- Stock Adjust -->
		<modal class="section-titles-modal" size="medium" v-if="isShowUpdateStock" @close="isShowUpdateStock = false">
			<div slot="header">
				<h3>
					<span v-if="stockUpdateType === 'sync'">Adjust</span>
					<span v-if="stockUpdateType === 'increase'">Add</span>
					<span v-if="stockUpdateType === 'decrease'">Reduce</span>
					<span> Stock</span>
					<span> - {{ stockTypeLabel }}</span>
					<span v-if="isApplyToAll"> - Apply To All Variants</span>
				</h3>
			</div>
			<div slot="body">
				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label class="font-weight-bold">
								<span>Stock </span>
								<span v-if="stockUpdateType === 'sync'">Quantity</span>
								<span class="text-success" v-if="stockUpdateType === 'increase'">Increment</span>
								<span class="text-danger" v-if="stockUpdateType === 'decrease'">Decrement</span>
							</label>
							<input type="text" class="form-control" placeholder="0" min="0" @change="stockInputValidation"
								@input=stockInputValidation v-model="stockQty" />
							<div class="pc-input-desc" v-if="stockUpdateType === 'sync'">
								<p>Input your real product stock here</p>
							</div>
							<div class="pc-input-desc" v-if="isApplyToAll">
								<p class="text-danger text-bold">Stock will be applied to All Variants</p>
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-group">
							<label><b>Description</b></label>
							<textarea class="form-control" placeholder="Stock alteration description"
								v-model="stockDescription"></textarea>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowUpdateStock = false">
					Cancel
				</button>
				<button class="btn btn-primary" :class="{ 'is-loading': isUpdatingStock }" @click="
					updateStock(
						productId,
						stockUpdateType,
						stockQty,
						stockDescription,
						stockVariation,
					)
					">
					<i class="material-icons">save</i>
					<span>{{ $t('Save') }}</span>
				</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import productsApi from '@/api/products';
import Modal from '@/components/Modal.vue';
import { StockUpdate } from '@/lib/statics';
import { toTitleCase } from '@/lib/helper';

export default {
	props: {
		product: {
			type: Object,
			default: null,
		},
		isEditProduct: {
			type: Boolean,
			default: true,
		},
		isFullWidth: {
			type: Boolean,
			default: true,
		},
		stockType: {
			type: String,
			default: 'catalog',
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			stockUpdateType: 'sync',
			stockQty: 0,
			stockDescription: '',
			globalStockQty: 0,
			globalStockDescription: '',
			stockVariation: null,
			isShowUpdateStock: false,
			isUpdatingStock: false,
			isApplyToAll: false,
			productStockQuantity: 0,
		};
	},
	methods: {
		...mapActions({
			resetStepErrors: 'productCreator/resetStepErrors',
		}),

		/**
		 * Update Product Stock
		 *
		 * @param {string} productId Product ID
		 * @param {'increase' | 'decrease' | 'sync'} type Type of stock update
		 * @param {number} quantity Stock quantity
		 * @param {string} description Stock change description
		 * @param {string} [variation] Variation name
		 */
		updateStock(productId, type, quantity, description, variation) {
			this.isUpdatingStock = true;
			const params = {
				type,
				quantity,
				description,
				stock_type: this.stockType,
			};
			if (variation) {
				params.variation = variation;
			}

			if (this.isApplyToAll) {
				params.apply_to_all = true;
			}

			const callback = (response) => {
				if (variation) {
					const variationsPrices = response.data.variations.prices;
					this.updateVariationPricesStock(variationsPrices);
				} else {
					const stock = response.data.stock;
					if (stock) {
						if (this.stockType === 'wholesale') {
							this.product.distributor.stock.quantity = stock.quantity;
						} else {
							this.product.stock.quantity = stock.quantity;
						}
						this.productStockQuantity = stock.quantity;
					}
					if (this.isApplyToAll) {
						this.globalStockQty = this.product.stock.quantity;
					}
				}

				this.isUpdatingStock = false;

				this.$notify({
					group: 'productCreator',
					text: 'Stock successfully updated.',
					type: 'success',
				});

				this.resetStockUpdate();

				// Hide popup
				this.isShowUpdateStock = false;
				this.validateProductStock();
			};
			const errorCallback = () => {
				this.isUpdatingStock = false;
				this.$notify({
					group: 'productCreator',
					text: 'Stock update occurred an error, please try again.',
					type: 'danger',
				});
			};
			productsApi.updateStock(productId, params, callback, errorCallback);
		},

		/**
		 * Update Variation Prices Stock
		 * @param {VariationPrice[]} prices Variations Prices
		 */
		updateVariationPricesStock(prices) {
			for (
				let index = 0;
				index < this.product.variations.prices.length;
				index++
			) {
				const variationPrice = this.product.variations.prices[index];
				const sameNameIndex = prices.findIndex(
					price => price.name === variationPrice.name,
				);
				if (sameNameIndex !== -1) {
					const price = prices[sameNameIndex];
					this.product.variations.prices[index].stock.quantity =
						price.stock.quantity;
					if (this.isApplyToAll) {
						this.globalStockQty = price.stock.quantity;
					}
				}
			}
		},

		/**
		 * Reset stock update value
		 */
		resetStockUpdate() {
			this.stockQty = 0;
			this.stockDescription = '';
			this.stockVariation = null;
		},

		/**
		 * Show adjust stock popup
		 *
		 * @param {number} quantity Stock Quantity
		 * @param {string} [variation] the variation name whose stock you want to change.
		 */
		showAdjustStock(quantity, variation, isApplyToAll = false) {
			this.stockQty = quantity;
			this.stockUpdateType = StockUpdate.TYPE_SYNC;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
			this.isApplyToAll = isApplyToAll;
		},
		showReduceStock(variation, isApplyToAll = false) {
			this.stockUpdateType = StockUpdate.TYPE_DECREASE;
			this.stockQty = 0;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
			this.isApplyToAll = isApplyToAll;
		},
		showAddStock(variation, isApplyToAll = false) {
			this.stockUpdateType = StockUpdate.TYPE_INCREASE;
			this.stockQty = 0;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation;
			}
			this.isApplyToAll = isApplyToAll;
		},
		parsePricing(price) {
			if (typeof price !== 'string') {
				price = price.toString();
			}

			let parsedPrice = price.replace(/[^0-9]/g, '').trim();
			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}

			return parsedPrice;
		},
		onStockChange() {
			this.productStockQuantity = this.parsePricing(this.productStockQuantity);
			this.product.stock.quantity = this.productStockQuantity;
		},
		stockInputValidation() {
			if (this.stockQty < 0) {
				this.stockQty = 0;
			} else {
				this.stockQty = this.parsePricing(this.stockQty);
			}
		},
		isNewVariation(variation) {
			const prices = this.product?.variations?.prices;
			const variations = prices.filter((price) => {
				const hasIdProperty = Object.prototype.hasOwnProperty.call(price, 'id');
				const property = hasIdProperty ? 'id' : 'name';
				return price[property] === variation[property];
			});

			return variations.length === 0;
		},
		onVariableStockChange(value) {
			value.stock.quantity = this.parsePricing(value.stock.quantity);
		},
		onGlobalStockChange() {
			this.globalStockQty = this.parsePricing(this.globalStockQty);
		},
		assignFirstVariantStock() {
			const variations = this.product?.variations?.prices ?? [];
			const isTypeVariable = this.product?.type === 'variable';
			if (isTypeVariable && variations && variations.length > 0) {
				const qty = variations[0]?.stock?.quantity ?? 0;
				this.globalStockQty = this.parsePricing(qty);
			}
		},
		initProductStockQuantity() {
			if (this.product) {
				if (this.stockType === 'wholesale') {
					this.productStockQuantity = this.product?.distributor?.stock?.quantity ?? 0;
				} else {
					this.productStockQuantity = this.product?.stock?.quantity ?? 0;
				}
			}
		},
	},
	computed: {
		...mapGetters({
			isFieldError: 'productCreator/isFieldError',
			getErrorMessage: 'productCreator/getErrorMessage',
		}),
		productId() {
			const id = this.product?._id ?? null;

			return id;
		},
		stockTypeLabel() {
			return toTitleCase(this.stockType);
		},
	},
	mounted() {
		this.resetStepErrors();
		this.assignFirstVariantStock();
		this.initProductStockQuantity();
	},
};
</script>

<style scoped>
.apply-to-all {
	background-color: #E6F0F980;
	border-radius: 8px;
}
</style>
